var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSoloNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.764 15.721l-1.02-1.02c-.264-.264-.785-.48-1.157-.48h-5.174c-.372 0-.893.216-1.157.48l-1.02 1.02-3.812 3.812h-.001v.002a1.43 1.43 0 00-.264 1.653c.068.136.152.265.264.379.113.112.242.197.378.264a1.433 1.433 0 001.655-.264l2.8-2.802c.264-.264.48-.173.48.2v4.988c0 .322.23.58.532.65v.029h5.464v-.03a.672.672 0 00.532-.649v-4.988c0-.373.216-.464.48-.2l2.8 2.802c.45.448 1.117.532 1.656.264.135-.068.264-.152.376-.264a1.43 1.43 0 00.265-.379 1.431 1.431 0 00-.265-1.655l-3.812-3.812zM17.899 13.213c.673-.717 1.008-1.323 1.008-2.936A2.792 2.792 0 0016 7.37a2.792 2.792 0 00-2.907 2.907c0 1.613.334 2.219 1.008 2.936.618.45 1.275.515 1.899.515.624 0 1.281-.064 1.899-.515"
  })))));
}

export default SvgIconSoloNew;